import { useEffect, useState } from "react";

/** Match Bootstrap `md` and `data-table-sticky-list-wrap` mobile rules (max-width: 767.98px). */
const PHONE_VIEWPORT_MQ = "(max-width: 767.98px)";

export function usePhoneViewport(): boolean {
    const [phone, setPhone] = useState(
        () => typeof window !== "undefined" && window.matchMedia(PHONE_VIEWPORT_MQ).matches
    );
    useEffect(() => {
        const mq = window.matchMedia(PHONE_VIEWPORT_MQ);
        const handler = () => setPhone(mq.matches);
        if (typeof mq.addEventListener === "function") {
            mq.addEventListener("change", handler);
        } else {
            mq.addListener(handler);
        }
        setPhone(mq.matches);
        return () => {
            if (typeof mq.removeEventListener === "function") {
                mq.removeEventListener("change", handler);
            } else {
                mq.removeListener(handler);
            }
        };
    }, []);
    return phone;
}
